









































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import alert from '@/store/modules/alert';
import user from '@/store/modules/user';
import {User} from '@/store/models';

@Component({
  components: {},
})
export default class NewsModal extends Vue {
  get name() {
    return alert.news;
  }
  get user(): User | null {
    return user.user;
  }
}
